module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mbnskms4-257946d98d1852721e9d7fdd871716ab.jpg";